import { useEffect } from 'react'


const useHumbleTheme = (condition = true) => {
  useEffect(() => {
    if (condition) {
      document.body.classList.add('humbleLayout')
      document.body.classList.add('humbleBgColor')
    }

    return () => {
      if (condition) {
        document.body.classList.remove('humbleLayout')
        document.body.classList.remove('humbleBgColor')
      }
    }
  }, [ condition ])
}


export default useHumbleTheme
